/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../../constants/constants";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import {
  JSONToCSVConvertor,
  bulkReqTracker,
} from "../../../../helpers/helperFunctions";
import _ from "lodash";
// import mixpanel from "mixpanel-browser";

let _dateFormat = dateFormat + ":ss";

const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Grey Spot Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  this.finalData = null;
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      console.log("Processing");

      let soundTypeData = [];
      resp[0].resp || [];
      console.log(resp.map((r) => [r.params.key, r.resp.length]));
      for (let idx in resp) {
        soundTypeData.push(
          ...resp[idx].resp.map((alarm) => {
            alarm.vehicleid = resp[idx].params.key;
            alarm.latitude = resp[idx].params.lat;
            alarm.longitude = resp[idx].params.long;
            return alarm;
          })
        );
      }

      console.log(data);

      if (schema.content[0].ref) {
        schema.content[0].ref.setData({
          soundTypeData,
          starttime: data.starttime.unix() * 1000,
          endtime: data.endtime.unix() * 1000,
        });
      }
    };

    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
    }

    let apiQ = [];

    for (let idx in data.vehicle) {
      apiQ.push({
        api: ReportAPIs.soundTypeHistory,
        key: data.vehicle[idx].data.vehicleid,
        body: {
          vehicleid: data.vehicle[idx].data.vehicleid,
          starttime: data.starttime.unix() * 1000,
          endtime: data.endtime.unix() * 1000,
        },
      });
    }
    bulkReqTracker(apiQ, handleSuccess);
  } else {
    window.graphDataErr = "";

    console.log("inside else");
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    // window.dispatchStoreEvent({
    //   type: actions.GRAPHSET_STATE_CHANGED,
    //   data: 0,
    // });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
};

const selectAllVehicles = () => {
  if (schema.toolbar[0].ref) {
    schema.toolbar[0].ref.selectAll();
    schema.toolbar[0].ref.setInputValue("");
  }
};

const schema = {
  key: "grey_spot_report",
  name: "Grey Spot",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      // onItemChange:changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Grey Spots",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: () => {
        // mixpanel.track("User Downloads Grey Spot Report", {
        //   Platform: "Web",
        //   Application: "Web",
        //   Screen: "Report",
        // });
        if (this.finalData) {
          JSONToCSVConvertor(this.finalData, "ViewReport", false);
        }
      },
    },
  ],
  content: [
    {
      key: "greyspotter",
      type: schemaTypes.IN_GREY_SPOTTER,
      selectAllVehicles,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;
